import { authConfig } from '@consigli/hooks';
import { logout } from '@consigli/oauth';

import type { FC } from 'react';

export const AccessDenied: FC = () => (
  <div className="flex flex-col items-center justify-center min-h-screen gap-4">
    <h1 className="text-lg font-bold">
      You need to be a member of the AECOM AI Engineering team to view this page.
    </h1>
    <button
      className="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300 transition-colors"
      onClick={() => logout(authConfig)}
    >
      Logout
    </button>
  </div>
);
